import { useEffect, useRef } from 'react';
/**
 * Helper hook to manage a timer reference.
 * @returns A ref to the timer.
 */
export function useTimerRef() {
    const timerRef = useRef(null);
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, []);
    return timerRef;
}
